export default "__VITE_ASSET__CVwSCw$y__"